
import request from '../utils/request'

//官网首页工程案例简略信息
function getHomeProject(data){
    return request({
        url : '/projectExample/getHomeProject',
        method : 'post',
        data
    });
}
//官网工程案例分页列表
function getPageProjectList(data){
    return request({
        url : '/projectExample/getPageProjectList',
        method : 'post',
        data
    });
}

function selectProjectInfoById(data){
    return request({
        url : '/projectExample/selectProjectInfoById',
        method : 'post',
        data
    });
}


export default {
    getHomeProject,
    getPageProjectList,
    selectProjectInfoById
}